import { resetLeaguePageCaches } from './leaguePageCache';

const SCORECLASH_PREFIX = 'scoreclash.';

/**
 * Wipe client-side session/user data (logout, expiry, or before a new login).
 * Auth JWT is origin-scoped localStorage — never shared across www vs apex.
 *
 * @param {{ preserveKeys?: string[] }} [options]
 */
export function clearClientSessionData({ preserveKeys = [] } = {}) {
  const preserve = new Set(preserveKeys);

  try {
    if (!preserve.has('token')) {
      localStorage.removeItem('token');
    }

    const localKeys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(SCORECLASH_PREFIX) && !preserve.has(key)) {
        localKeys.push(key);
      }
    }
    for (const key of localKeys) {
      localStorage.removeItem(key);
    }
  } catch {
    /* private mode / disabled storage */
  }

  try {
    const sessionKeys = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && !preserve.has(key)) {
        sessionKeys.push(key);
      }
    }
    for (const key of sessionKeys) {
      sessionStorage.removeItem(key);
    }
  } catch {
    /* private mode / disabled storage */
  }

  resetLeaguePageCaches();
}
